module.exports = __webpack_public_path__ + "img/1-0-office-clearing-bg.28a8ae26.png";